/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoringTemplateTrackCurveRequest
 */
export interface MonitoringTemplateTrackCurveRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    mnemonicId: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    unitId: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    lineType: MonitoringTemplateTrackCurveRequestLineTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    lineColor?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    lineThickness?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    limitMin?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    limitMax?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    curveLimitMin?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    curveLimitMax?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    curveLimitColor?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    limitMinAuto?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoringTemplateTrackCurveRequest
     */
    limitMaxAuto?: boolean;
}


/**
 * @export
 */
export const MonitoringTemplateTrackCurveRequestLineTypeEnum = {
    Line: 'LINE',
    Point: 'POINT',
    Value: 'VALUE'
} as const;
export type MonitoringTemplateTrackCurveRequestLineTypeEnum = typeof MonitoringTemplateTrackCurveRequestLineTypeEnum[keyof typeof MonitoringTemplateTrackCurveRequestLineTypeEnum];


/**
 * Check if a given object implements the MonitoringTemplateTrackCurveRequest interface.
 */
export function instanceOfMonitoringTemplateTrackCurveRequest(value: object): value is MonitoringTemplateTrackCurveRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('mnemonicId' in value) || value['mnemonicId'] === undefined) return false;
    if (!('unitId' in value) || value['unitId'] === undefined) return false;
    if (!('lineType' in value) || value['lineType'] === undefined) return false;
    return true;
}

export function MonitoringTemplateTrackCurveRequestFromJSON(json: any): MonitoringTemplateTrackCurveRequest {
    return MonitoringTemplateTrackCurveRequestFromJSONTyped(json, false);
}

export function MonitoringTemplateTrackCurveRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringTemplateTrackCurveRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'mnemonicId': json['mnemonicId'],
        'unitId': json['unitId'],
        'lineType': json['lineType'],
        'lineColor': json['lineColor'] == null ? undefined : json['lineColor'],
        'lineThickness': json['lineThickness'] == null ? undefined : json['lineThickness'],
        'limitMin': json['limitMin'] == null ? undefined : json['limitMin'],
        'limitMax': json['limitMax'] == null ? undefined : json['limitMax'],
        'curveLimitMin': json['curveLimitMin'] == null ? undefined : json['curveLimitMin'],
        'curveLimitMax': json['curveLimitMax'] == null ? undefined : json['curveLimitMax'],
        'curveLimitColor': json['curveLimitColor'] == null ? undefined : json['curveLimitColor'],
        'limitMinAuto': json['limitMinAuto'] == null ? undefined : json['limitMinAuto'],
        'limitMaxAuto': json['limitMaxAuto'] == null ? undefined : json['limitMaxAuto'],
    };
}

export function MonitoringTemplateTrackCurveRequestToJSON(value?: MonitoringTemplateTrackCurveRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'mnemonicId': value['mnemonicId'],
        'unitId': value['unitId'],
        'lineType': value['lineType'],
        'lineColor': value['lineColor'],
        'lineThickness': value['lineThickness'],
        'limitMin': value['limitMin'],
        'limitMax': value['limitMax'],
        'curveLimitMin': value['curveLimitMin'],
        'curveLimitMax': value['curveLimitMax'],
        'curveLimitColor': value['curveLimitColor'],
        'limitMinAuto': value['limitMinAuto'],
        'limitMaxAuto': value['limitMaxAuto'],
    };
}

